import React from "react";
import { Admin, Resource } from 'react-admin';
import { CourseCreate, CourseList } from "./components/admin/course";
import myDataProvider from "./providers/myDataProvider";
import CourseEdit from "./components/admin/courseEdit";
import { VideoList, VideoCreate } from "./components/admin/video";
import UserList from "./components/admin/user";
import UserShow from "./components/admin/userShow";
import UserEdit from "./components/admin/userEdith";
import { UserCreate } from "./components/admin/userCreate";
import { RoleList } from "./components/admin/roleList";
import { RoleShow } from "./components/admin/roleShow";
import ImageList from "./components/admin/imageList"
import PublishedCourseList from "./components/admin/publishedCourseList";
import PaymentList from "./components/admin/paymentList";
import useSessionChecker from "./hooks/useSessionChecker";
import { NewsList } from "./components/admin/news/newsList";
import { NewsEdith } from "./components/admin/news/newsEdit";
import { NewsCreate } from "./components/admin/news/newsCreate";

const AdminApp = () => {
    useSessionChecker();
    return (
        <Admin basename="/admin" dataProvider={myDataProvider} >
            <Resource name="courses"

             list={CourseList}
             create={CourseCreate}
             edit={CourseEdit}
             />
             <Resource name="videos"
             list={VideoList}
             create={VideoCreate}
             />
             <Resource name="users" 
             list={UserList}
             show={UserShow} 
             edit={UserEdit}
             create={UserCreate}
             />
             
             <Resource name="roles"
             list={RoleList}
             show={RoleShow}
             />
             <Resource name="images" 
             list={ImageList} />

             <Resource name="published-courses"
             list={PublishedCourseList}
             />
             <Resource name="payments" 
             list={PaymentList} 
             />
             <Resource name="news"
             list={NewsList}
             create={NewsCreate}
             edit={NewsEdith}

             />

        </Admin>
    )
}

export default AdminApp;
